import { MenuProps } from 'antd';

import { AccessType } from 'types/User';

export type MenuItem = Required<MenuProps>['items'][number];

export const bottomNavigationItems = [
  {
    key: '/actualites',
    label: 'Actualités',
  },
  {
    key: '/calculer-prime',
    label: 'Calculer une prime',
    allowedForAccessType: [AccessType.SIMULATEUR],
  },
  {
    key: '/nouveau-dossier-concessionnaire',
    label: 'Demande de prime',
    allowedForAccessType: [AccessType.CONCESSIONNAIRE],
  },
  {
    key: '/tableau-des-primes',
    label: 'Tableau des primes',
    allowedForAccessType: [AccessType.CONCESSIONNAIRE],
  },
  {
    key: '/dossiers',
    label: 'Suivi des dossiers',
  },
  {
    key: 'https://www.ecologie.gouv.fr/dispositif-des-certificats-deconomies-denergie',
    label: 'Réglementation',
    target: '_blank',
  },
  {
    key: '/faq',
    label: 'FAQ',
  },
  {
    key: 'https://www.hellio.com/mentions-legales',
    label: 'Mentions légales',
  },
  {
    key: 'https://www.hellio.com/cgu',
    label: "Conditions générales d'utilisation",
  },
  {
    key: 'https://www.hellio.com/politique-confidentialite',
    label: 'Politique de confidentialité',
  },
  {
    key: '/ressources',
    label: 'Ressources',
    allowedForAccessType: [AccessType.SIMULATEUR],
  },
];
